import { FC, memo } from 'react';
import { createPortal } from 'react-dom';

import cx from 'clsx';

import { MediaPreviewItem } from './MediaPreviewItem';
import { TopBar, BottomBar } from './ActionBars';

import { useMediaPreview } from './use-media-preview';

import styles from './styles.module.css';

const MediaPreviewModalContent: FC = memo(() => {
  const { data, show, handleClose } = useMediaPreview();

  if (!data) {
    return null;
  }

  return (
    <div
      className={cx({
        [styles.container]: true,
        [styles.containerVisible]: show,
      })}
    >
      <div className={styles.content}>
        <TopBar />
        <div className={styles.mediaWrapper} onClick={handleClose}>
          <MediaPreviewItem data={data} isPreview={show} />
        </div>
        <BottomBar file={data} />
      </div>
    </div>
  );
});

export const MediaPreview = () =>
  createPortal(<MediaPreviewModalContent />, document.body);
